import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState = {
  textColor: '',
  btnColor: '',
  bgColor: '',
  formTextColor: '',
  formBtnColor: '',
  formBgColor: '',
  borderColor: '',
  separatorColor: '',
  bgAvailableDaysColor: '',
  unavailableDaysColor: '',
  hideDetails: 'false',
  fontFamily: '',
  isInline: 'false',
  teamTextColor: '',
  teamBgColor: '',
};

export const settingSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setBackgroundColor: (state, action) => {
      state.bgColor = action.payload;
    },
    setTextColor: (state, action) => {
      state.textColor = action.payload;
    },
    setBtnColor: (state, action) => {
      state.btnColor = action.payload;
    },
    setFormBackgroundColor: (state, action) => {
      state.formBgColor = action.payload;
    },
    setFormTextColor: (state, action) => {
      state.formTextColor = action.payload;
    },
    setFormBtnColor: (state, action) => {
      state.formBtnColor = action.payload;
    },
    setTeamTextColor: (state, action) => {
      state.teamTextColor = action.payload;
    },
    setTeamBackgroundColor: (state, action) => {
      state.teamBgColor = action.payload;
    },
    setBorderColor: (state, action) => {
      state.borderColor = action.payload;
    },
    setSeparatorColor: (state, action) => {
      state.separatorColor = action.payload;
    },
    setHideDetails: (state, action) => {
      state.hideDetails = action.payload;
    },
    setBgAvailableDaysColor: (state, action) => {
      state.bgAvailableDaysColor = action.payload;
    },
    setUnavailableDaysColor: (state, action) => {
      state.unavailableDaysColor = action.payload;
    },
    setFontFamily: (state, action) => {
      state.fontFamily = action.payload;
    },
    setIsInline: (state, action) => {
      state.isInline = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setBackgroundColor,
  setTextColor,
  setBtnColor,
  setFormBackgroundColor,
  setFormTextColor,
  setFormBtnColor,
  setTeamTextColor,
  setTeamBackgroundColor,
  setHideDetails,
  setBorderColor,
  setSeparatorColor,
  setBgAvailableDaysColor,
  setUnavailableDaysColor,
  setFontFamily,
  setIsInline,
} = settingSlice.actions;

export const getSettingsState = (state: RootState) => state.settings;
export const getTextColor = (state: RootState) => state.settings.textColor;

export default settingSlice.reducer;
